export default __webpack_public_path__ + "static/media/request-mention.87845a73.svg";